import * as React from 'react';
import { Header } from '../components/Header';
import { Button, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import Modal from 'react-bootstrap/Modal';
import { Trans, useTranslation } from 'react-i18next';
export default function SignIn(props) {
    const { t } = useTranslation();
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');

    const [usernameError, setUsernameError] = React.useState('');
    const [show, setShow] = React.useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = (event) => {
        event.preventDefault();
        //Validate fields
        if (!username) {
            setUsernameError('Vui lòng nhập số điện thoại hoặc tên tài khoản');
        }
        else {
            setUsernameError('');
            fetch("https://booking.bernard.vn/api/auth/login", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    username: username,
                    password: password,
                })
            })
                .then(r => r.json())
                .then(r => {
                    if ('success' === r.message) {
                        localStorage.setItem("user", JSON.stringify({ person_code: r.person_code, token: r.token }))
                        window.location.href = "/";
                    } else {
                        handleShow();
                    }
                })
        }
    };

    return (

        <div className='page-fullscreen'>
            <Modal centered show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('login_fail')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Trans i18nKey="login_fail_message">
                        <Link to="/register"></Link>
                        <Link to="tel:+842835352468"></Link>
                        <Link to="tel:+84911072200"></Link>
                    </Trans>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        {t('close')}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Header />
            <div className='page-content'>
                <Row style={{ height: 100 + '%', margin: 0 }}>
                    <div className='col-lg-6 col-xs-12 blue-bg'>
                        <div className='left-panel'>
                            <div className='login-form vertical-center'>
                                <div className='form-heading'>
                                    <div className='title'>
                                        {t('say_hi')}
                                    </div>
                                    <div className='sub-title'>
                                        {t('welcome')}
                                    </div>
                                </div>
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mt-3">
                                        <Form.Control name='username' type="text" value={username} placeholder={t('enter_phone_number')} isInvalid={usernameError !== ''} onChange={(e) => setUsername(e.target.value)} />
                                        {usernameError && (
                                            <Form.Control.Feedback type="invalid">
                                                {usernameError}
                                            </Form.Control.Feedback>
                                        )}
                                        <Form.Control name='password' type="password" value={password} placeholder={t('password')} onChange={(e) => setPassword(e.target.value)} />
                                        <Form.Check type='checkbox' id="chkRemember" label={t('remember')} />
                                    </Form.Group>
                                    <Form.Group className='mt-3' style={{ display: 'flex', flexDirection: 'row' }}>
                                        <Button type='submit' className='submit' style={{ width: 100 + '%' }}>{t('signin')}</Button>
                                    </Form.Group>
                                    <Form.Group className='mt-3' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <Link to={'/register'}>{t('do_not_have_account_please_press')}<span style={{color: "#B98737"}}> {t('register')}</span>.</Link>
                                    </Form.Group>
                                    <Form.Group className='mt-3' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <Link to={'/forgotPassword'}>{t('forgot_password')}</Link>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                    <div className='right-panel col-lg-6 col-xs-12' style={{ backgroundImage: "url(/images/bg-1.png)", backgroundSize: 'cover' }}>
                    </div>
                </Row>
            </div>
            <Footer />
        </div >
    );
}